import { useContext } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { Divider, ToastContext } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import useIntegration from './hooks/useIntegration'
import IntegrationDetailBody from './IntegrationDetailBody/IntegrationDetailBody'
import IntegrationInfo from './IntegrationInfo/IntegrationInfo'
import * as Styles from './styles'

const IntegrationsDetailConfiguration = () => {
  const { id } = useParams()
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const location = useLocation()
  const { integration, hasChanges, revertChanges, onChangeIntegration, onSave } = useIntegration({
    id,
    selectedIntegration: location.state?.selectedIntegration,
    storeId: info.selectedStore.id,
    setToastInfo,
  })

  return (
    <Styles.Container>
      <IntegrationInfo integration={integration} />
      <Divider />
      <IntegrationDetailBody
        integration={integration}
        storeId={info.selectedStore.id}
        onChange={onChangeIntegration}
        hasChanges={hasChanges}
        onRevertChanges={revertChanges}
        onSave={onSave}
      />
    </Styles.Container>
  )
}

export default IntegrationsDetailConfiguration
